import { styled, CSSObject } from '@common'
import { media } from '@theme'

const MobileImgDisplay = {
    display: 'block',
    top: 0,
    left: 0,
    width: '100%',
}

const TabletImgDisplay = {
    display: 'block',
    top: 0,
    left: 0,
    width: '100%',
}

const DesktopImgDisplay:CSSObject = {
    display: 'block',
}

export const Img = styled.img({
    display: 'none',
    width: '100%',
    '.mobile &.mobile': MobileImgDisplay,
    '&.mobile': {
        [media.mobile]: {
            '.tablet &': { display: 'none' },
            '.desktop &': { display: 'none' },
            ...MobileImgDisplay
        },
    },

    '.tablet &.tablet': TabletImgDisplay,
    '&.tablet': {
        [media.tablet]: {
            '.mobile &': { display: 'none' },
            '.desktop &': { display: 'none' },
            ...TabletImgDisplay
        },
    },

    '.desktop &.desktop': DesktopImgDisplay,
    '&.desktop': {
        [media.desktop]: {
            '.mobile &': { display: 'none' },
            '.tablet &': { display: 'none' },
            ...DesktopImgDisplay,
        }
    },
})
